<div *ngFor="let chart of panelCharts" [id]="chart.title" [style]="getFlex()" class="chart">
  <app-spinner class="primary full"></app-spinner>
</div>

